import { ReactComponent as ArchTarget } from '../../assets/icons/arch-target.svg';
import styles from './index.module.css';
import React, { useEffect, useState } from 'react';
import useBreadcrumb from '../../hooks/useBreadcrumb';
import { useNavigate } from "react-router-dom";
import {
    Box,
    Stack,
    Typography,
    Card,
    CardContent,
    CardActionArea,
    CardMedia,
    Button,
    Grid,
} from "@mui/material";

function OnlineStore() {
    const { setBreadcrumb, clearBreadcrumb } = useBreadcrumb();
    const navigate = useNavigate();

    const [showComingSoon, setShowComingSoon] = useState(false);

    useEffect(() => {
        setBreadcrumb({
            title: "Online Store",
            links: [
                { title: "Home", url: "/" },
                { title: "Online Store", url: "/onlinestore" }
            ]
        });
        return clearBreadcrumb;
    }, []);
    const products = [
        {
            title: "Invacare Tracer EX2 Wheelchair",
            desc: "Durable, comfortable wheelchair for home and travel use.",
            price: "Contact for Price",
            img: "/assets/images/wheelchair.jpg",
            alttext: "Invacare Wheelchair"
        },
        {
            title: "Drive Medical Nitro Rollator",
            desc: "Lightweight rollator with storage bag and ergonomic hand brakes.",
            price: "Contact for Price",
            img: "/assets/images/rollator.jpg",
            alttext: "Drive Rollator"
        },
        {
            title: "Medline Walker with Brakes",
            desc: "Adjustable aluminum walker with easy-grip handles.",
            price: "Contact for Price",
            img: "/assets/images/walker.jpg",
            alttext: "Medline Walker"
        },
        {
            title: "Drive Medical Adjustable Cane",
            desc: "Lightweight cane with cushioned handle and adjustable height.",
            price: "Contact for Price",
            img: "/assets/images/canes.jpg",
            alttext: "Drive Cane"
        },
        {
            title: "Hugo Folding Cane",
            desc: "Portable, collapsible cane for easy storage and mobility.",
            price: "Contact for Price",
            img: "/assets/images/crutches.jpg",
            alttext: "Hugo Cane"
        },
        {
            title: "Disposable Nitrile Gloves (100ct)",
            desc: "Medical-grade gloves offering protection and comfort.",
            price: "Contact for Price",
            img: "/assets/images/Nutrition-Feeding.jpg",
            alttext: "Nitrile Gloves"
        },
        {
            title: "3M N95 Respirator Mask (Pack of 10)",
            desc: "Reliable respiratory protection for healthcare and public use.",
            price: "Contact for Price",
            img: "/assets/images/MonitoringTools.jpg",
            alttext: "3M N95 Mask"
        },
        {
            title: "Diabetes Supply",
            desc: "Blood glucose monitoring supplies for accurate, fast, and convenient daily diabetes testing.",
            price: "Contact for Price",
            img: "/assets/images/freestyle-lite.png",
            alttext: "Diabetes Supply",
            link: "/medicalsupplies/diabetes"
        }
    ];


    const comingSoonItems = [
        "Wheelchair", "Rollators", "Walker", "U-Step Walker", "Cane",
        "Quad Canes", "Respirators", "Disposable Gloves",
        "Shower Chairs", "Wound Care & Support"
    ];

    return (
        <Box sx={{ background: "white" }}>
            <Box className={styles.content}>
                <Stack direction="column">
                    <Typography variant="h4" sx={{ my: "1rem" }}>
                        <span style={{ fontWeight: "normal" }}>Welcome! </span>
                        {/* <span style={{ fontWeight: "bold" }}>John Doe</span> */}
                    </Typography>
                    <Typography sx={{ color: "#6d6d6d", mt: -1 }}>
                        How are you feeling today?
                    </Typography>
                </Stack>
                <Box
                    sx={{
                        p: 5,
                        mt: 5,
                        boxShadow: "0 4px 20px rgba(0,0,0,0.08)",
                        borderRadius: "16px",
                        background: "white",
                        position: "relative"
                    }}
                >
                    <Stack direction="row" justifyContent="space-between" alignItems="center">
                        <Typography
                            sx={{
                                fontSize: "1.3rem",
                                fontWeight: 600,
                                color: "#0a9a73"
                            }}
                        >
                            {showComingSoon ? "Coming Soon Items" : "Online Store Items"}
                        </Typography>

                        <Button
                            variant="contained"
                            sx={{
                                px: { xs: 2, sm: 2, md: 3 },
                                py: { xs: 0.5, sm: 1 },
                                fontSize: { xs: "0.75rem", sm: "0.85rem", md: "0.95rem" },
                            }}
                            onClick={() => setShowComingSoon(!showComingSoon)}
                        >
                            {showComingSoon ? "Show Store Items" : "Show Coming Soon Items"}
                        </Button>
                    </Stack>
                    {!showComingSoon ? (
                        <Grid container spacing={3} sx={{ mt: 2 }}>
                            {products.map((p, index) => (
                                <Grid item xs={12} sm={6} md={4} lg={3} key={index}>
                                    <Card
                                        onClick={p.link ? () => navigate(p.link) : undefined}
                                        sx={{
                                            borderRadius: "12px",
                                            textAlign: "center",
                                            padding: "1.5rem",
                                            height: "355px",
                                            border: "solid 0.5px lightgrey",
                                            "&:hover": { boxShadow: "0px 0px 6px #0a9a73" },cursor: p.link ? "pointer" : "default"
                                        }}
                                    >
                                        <CardMedia component="img" sx={{
                                            height: 150,
                                            width: "100%",
                                            objectFit: "contain",
                                            borderRadius: "8px",
                                            background: "#fff",
                                            border: "1px solid lightgrey"

                                        }} src={p.img} alt={p.alttext}
                                        />
                                        <CardContent>
                                            {/* <img
                                                src={p.img}
                                                alt={p.alttext}
                                                height={120}
                                                width={120}
                                            /> */}
                                            <Typography sx={{ fontWeight: 700, mt: 2 }}>
                                                {p.title}
                                            </Typography>

                                            <Typography sx={{ mt: 1, color: "#444" }}>
                                                {p.desc}
                                            </Typography>

                                            <Typography
                                                sx={{
                                                    color: "#0a9a73",
                                                    fontWeight: 600,
                                                    mt: 2,
                                                    cursor: "pointer"
                                                }}
                                            >
                                                {p.price}
                                            </Typography>
                                        </CardContent>
                                    </Card>
                                </Grid>
                            ))}
                        </Grid>
                    ) : (
                        <Grid container spacing={3} sx={{ mt: 2 }}>
                            {comingSoonItems.map((item, index) => (
                                <Grid item xs={12} sm={6} md={3} lg={2.4} key={index}>
                                    <CardActionArea sx={{ borderRadius: "8px", display: "block" }}>
                                        <Card
                                            sx={{
                                                borderRadius: "6px",
                                                background: "#EFFFF9",
                                                border: "1.5px solid #0a9a73",
                                                textAlign: "center",
                                                padding: "1rem",
                                                cursor: "pointer",
                                                transition: "0.2s",
                                                "&:hover": {
                                                    boxShadow: "0px 0px 10px rgba(10, 154, 115, 0.3)"
                                                }
                                            }}
                                        >
                                            <Typography sx={{ fontWeight: 600 }}>
                                                {item}
                                            </Typography>
                                        </Card>
                                    </CardActionArea>
                                </Grid>
                            ))}
                        </Grid>
                    )}

                </Box>
            </Box>
        </Box>
    );
}

export default OnlineStore;